import { ReactNode } from "react"
import { AppSidebar, AppTabs } from "@/components/AppNavigation"
import { ModalsProvider } from "@/hooks/useModals"
import NotificationBanner from "@/components/NotificationBanner"
import SEO from "@/components/SEO"
import PromotionsBanner from "@/components/PromotionsBanner"
import PWABanner from "@/components/PWABanner"
import Toaster from "@/components/Toaster"

const AppLayout = ({
  children,
  hideBanners = false,
  hideTabs = false,
  guestMode = false,
}: {
  children: ReactNode
  hideBanners?: boolean
  hideTabs?: boolean
  guestMode?: boolean
}) => (
  <>
    <SEO />

    <ModalsProvider>
      {!hideBanners && (
        <>
          <div className="xl:pl-64">
            <PromotionsBanner />
          </div>
          <PWABanner />
        </>
      )}
      <AppSidebar guestMode={guestMode} />
      <div className="relative flex flex-1 flex-col bg-gray-50 xl:pl-64">
        <div className="flex flex-1 flex-col">
          {!hideBanners && <NotificationBanner />}
          {children}
        </div>
        {!hideTabs && <AppTabs />}
      </div>
    </ModalsProvider>
    <Toaster />
  </>
)

export default AppLayout
